import React from "react";
import { useIntl } from "react-intl";

import "./styles.scss";

const ProgressBar = ({
  steps,
  startFrom,
  currentStep,
  onChange,
  stepsFilled
}) => {
  const { formatMessage } = useIntl();

  const stringInt = val => formatMessage({ id: val });

  const isInactive = dependsOn => {
    if (dependsOn.length === 0) return false;

    const dependenciesValidation = dependsOn.map(stepFilled =>
      stepsFilled.includes(stepFilled)
    );

    if (dependenciesValidation.every(Boolean)) {
      return false;
    }

    return true;
  };

  return (
    <div className="progress-circle">
      {steps.map((step, stepIdx) => {
        if (!step.allowedOnStartTypes.includes(startFrom)) return null;

        return (
          <span
            key={stepIdx}
            onClick={() => {
              if (isInactive(step.dependsOn)) return;

              onChange(stepIdx);
            }}
            className={
              isInactive(step.dependsOn)
                ? "is-inactive"
                : currentStep > stepIdx
                ? "is-done"
                : currentStep === stepIdx
                ? "is-selected"
                : "not-filled"
            }
          >
            <step.icon size={25} />
            <p>{step.barLabel(stringInt)}</p>
          </span>
        );
      })}
    </div>
  );
};

export default ProgressBar;
